// extracted by mini-css-extract-plugin
export default {"wrapper":"overlay__wrapper-fjJGE","overlay":"overlay__overlay-Vn6We"};